import Vue from 'vue' ;
import Router from 'vue-router';

// 路由组件
import error from '@/pages/error';
import mainFrame from '@/pages/mainFrame';
import home from '@/pages/home/index';
import login from '@/pages/login/index';

// 新闻管理
import news from '@/pages/news/frame';
import newsList from '@/pages/news/list';
import newsDetail from '@/pages/news/detail';
import newsAdd from '@/pages/news/add';
import newsEdit from '@/pages/news/edit';

// 新闻管理
import certificate from '@/pages/certificate/frame';
import certificateList from '@/pages/certificate/list';
import certificateDetail from '@/pages/certificate/detail';
import certificateAdd from '@/pages/certificate/add';
import certificateEdit from '@/pages/certificate/edit';
import certificateConfig from '@/pages/certificate/config';

// 课程配置
import course from '@/pages/course/frame';
import courseList from '@/pages/course/list';
import courseAdd from '@/pages/course/add';
import courseDetail from '@/pages/course/detail';
import courseEdit from '@/pages/course/edit';

// 课程签到
import checkin from '@/pages/checkin/frame';
import checkinList from '@/pages/checkin/list';

//系统管理
import system from '@/pages/system/frame';//外层架子；
import leftMenuManager from '@/pages/system/leftMenuManager';
import userManager from '@/pages/system/userManager';
import roleManager from '@/pages/system/roleManager';
import functionManager from '@/pages/system/functionManager';
//公共
import editPwd from '@/pages/commonPage/editPwd'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:'登录'}
    },
    {
      path: '/mainFrame',
      name: 'mainFrame',
      component: mainFrame,
      children:[
        {
          path: '/404',
          name: 'error',
          component: error,
          meta:{title:'404'}
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:'首页',isShowBread:false,matchLeftKey:'/home'}
        },
        {
          path: '/news',
          name: 'news',
          component: news,
          meta:{title:'新闻管理'},
          children:[
            {
              path: 'list',
              name: 'newsList',
              component: newsList,
              meta:{title:'新闻列表',isShowBread:true,matchLeftKey:'/news/list'}
            },
            {
              path: 'add',
              name: 'newsAdd',
              component: newsAdd,
              meta:{title:'新增新闻',isShowBack:true,isShowBread:true,matchLeftKey:'/news/add'}
            },
            {
              path: 'edit',
              name: 'newsEdit',
              component: newsEdit,
              meta:{title:'编辑新闻',isShowBack:true,isShowBread:true,matchLeftKey:'/news/edit'}
            },
            {
              path: 'detail',
              name: 'newsDetail',
              component: newsDetail,
              meta:{title:'新闻详情',isShowBack:true,isShowBread:true,matchLeftKey:'/news/detail'}
            },
          ]
        },
        {
          path: '/certificate',
          name: 'certificate',
          component: certificate,
          meta:{title:'证书颁发'},
          redirect:'/certificate/list',
          children:[
            {
              path: 'list',
              name: 'certificateList',
              component: certificateList,
              meta:{title:'证书列表',isShowBread:true,matchLeftKey:'/certificate/list'}
            },
            {
              path: 'add',
              name: 'certificateAdd',
              component: certificateAdd,
              meta:{title:'新增证书',isShowBack:false,isShowBread:true,matchLeftKey:'/certificate/add'}
            },
            {
              path: 'edit',
              name: 'certificateEdit',
              component: certificateEdit,
              meta:{title:'编辑证书',isShowBack:true,isShowBread:true,matchLeftKey:'/certificate/edit'}
            },
            {
              path: 'detail',
              name: 'certificateDetail',
              component: certificateDetail,
              meta:{title:'证书详情',isShowBack:true,isShowBread:true,matchLeftKey:'/certificate/detail'}
            },
            {
              path: 'config',
              name: 'certificateConfig',
              component: certificateConfig,
              meta:{title:'证书配置',isShowBack:false,isShowBread:true,matchLeftKey:'/certificate/config'}
            },
          ]
        },
        {
          path: '/course',
          name: 'course',
          component: course,
          meta:{title:'课程配置'},
          children:[
            {
              path: 'list',
              name: 'courseList',
              component: courseList,
              meta:{title:'课程列表',isShowBread:true,matchLeftKey:'/course/list'}
            },
            {
              path: 'add',
              name: 'courseAdd',
              component: courseAdd,
              meta:{title:'新增课程',isShowBack:true,isShowBread:true,matchLeftKey:'/course/add'}
            },
            {
              path: 'edit',
              name: 'courseEdit',
              component: courseEdit,
              meta:{title:'编辑课程',isShowBack:true,isShowBread:true,matchLeftKey:'/news/edit'}
            },
            {
              path: 'detail',
              name: 'courseDetail',
              component: courseDetail,
              meta:{title:'课程详情',isShowBack:true,isShowBread:true,matchLeftKey:'/course/detail'}
            },
          ]
        },
        {
          path: '/checkin',
          name: 'checkin',
          component: checkin,
          meta:{title:'课程签到'},
          children:[
            {
              path: 'list',
              name: 'checkinList',
              component: checkinList,
              meta:{title:'签到列表',isShowBread:true,matchLeftKey:'/checkin/list'}
            },
          ]
        },
        //公共
        {
            path: '/editPwd',
            name: 'editPwd',
            component: editPwd
        },
        //系统管理
        {
          path:'/system',
          name:'system',
          component:system,
          meta:{title:"系统管理"},
          children:[
            {
                path: 'leftMenuManager',
                name: 'leftMenuManager',
                component: leftMenuManager,
                meta:{title:'菜单管理',isShowBread:true,matchLeftKey:'/system/leftMenuManager'}
            },
             {
                path: 'userManager',
                name: 'userManager',
                component: userManager,
                meta:{title:'用户管理',isShowBread:true,matchLeftKey:'/system/userManager'}
            },
            {
                path: 'roleManager',
                name: 'roleManager',
                component: roleManager,
                meta:{title:'角色管理',isShowBread:true,matchLeftKey:'/system/roleManager'}
            },
            {
                path: 'functionManager',
                name: 'functionManager',
                component: functionManager,
                meta:{title:'功能配置',isShowBread:true,matchLeftKey:'/system/functionManager'}
            }
          ]

        }

      ]
    },
    {
        path: '*',
        redirect: '/404'
    },

  ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++)
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}
router.beforeEach((to, from, next) => {
    // if(window.gtag){
    //   gtag('config', 'xxxx', {'page_path': to.fullPath})
    // }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "服装综合体官网管理后台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        // Message({
        //     message: "请先登录~",
        //     type: 'warning',
        //     duration: 1500
        // });
        setTimeout(function() {
            router.replace("/login")
        }, 100)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedSZHC")
    console.log("isLogined:"+isLogined)
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js